function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import Icon from "../elements/icon";
import BasicUtils from "../../utils/basic-utils"; // this.props.buttons should either be:
// an array of strings, which will be used as the label and the value of each button
// or
// objects with keys: [value (required), label, icon, disabled(bool), selected(bool)]
// can use 'label' or 'icon' or both
// 'disabled' can be used per button but the props.disabled == true will disable the entire control

var ButtonSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonSelect, _React$Component);

  var _super = _createSuper(ButtonSelect);

  function ButtonSelect() {
    _classCallCheck(this, ButtonSelect);

    return _super.apply(this, arguments);
  }

  _createClass(ButtonSelect, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        className: classNames("et--button-select", this.props.className)
      }, _.map(this.props.buttons, function (btn) {
        var disabled, gt_icon, icon, label, value;

        if (_.isString(btn)) {
          value = btn;
        } else {
          value = btn.value;
          label = btn.label;
          icon = btn.icon;
          gt_icon = btn.gt_icon;
          disabled = btn.disabled;
        }

        var selected = BasicUtils.makeArray(_this.props.selected);
        var enabled = !(_this.props.disabled || disabled);
        var classes = classNames("et--button-select--item", {
          "is-disabled": !enabled,
          "is-selected": enabled && _.contains(selected, value),
          "is-large": _this.props.large
        });
        return /*#__PURE__*/React.createElement("span", {
          key: value,
          className: classes,
          onClick: enabled ? function (evt) {
            return _this.props.onSelect(value, evt);
          } : undefined
        }, icon || gt_icon ? /*#__PURE__*/React.createElement(Icon, {
          className: "et--button-select--item-icon",
          icon: icon || gt_icon
        }) : undefined, label ? /*#__PURE__*/React.createElement("span", {
          className: "et--button-select--item-label"
        }, label) : undefined);
      }));
    }
  }]);

  return ButtonSelect;
}(React.Component);

_defineProperty(ButtonSelect, "displayName", "Button Select");

_defineProperty(ButtonSelect, "propTypes", {
  buttons: PropTypes.array.isRequired,
  selected: PropTypes.any,
  large: PropTypes.bool,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func.isRequired
});

export { ButtonSelect as default };